import command from "@utils/command";

// WLED Preset IDs
const PRESETS = {
  ELF_STRIPES: 4,
  ELF_BOUNCE: 7,
  PEPPERMINT_STRIPES: 3,
  PEPPERMINT_BOUNCE: 8,
  GLITTER: 1,
  GLITTER_TWINKLE: 6,
  // These have to be implemented
  FIREWORKS: 2,
  TWINKLE_STARS: 5,
};

export default {
  name: "MagicTree",
  data: function() {
    return {
      selectedColor: null,
      colorSwatches: [
        // Christmas classics first
        { hex: '#FF0000', name: 'Red' },
        { hex: '#00FF00', name: 'Green' },
        { hex: '#FFD700', name: 'Gold' },
        { hex: '#FFFFFF', name: 'White' },
        { hex: '#0000FF', name: 'Blue' },
        // More festive colors
        { hex: '#DC143C', name: 'Crimson' },
        { hex: '#32CD32', name: 'Lime' },
        { hex: '#FF8C00', name: 'Orange' },
        { hex: '#00FFFF', name: 'Cyan' },
        { hex: '#FF1493', name: 'Hot Pink' },
        // Soft/Pastel options
        { hex: '#FFB6C1', name: 'Light Pink' },
        { hex: '#90EE90', name: 'Light Green' },
        { hex: '#E6E6FA', name: 'Lavender' },
        { hex: '#FFE4E1', name: 'Misty Rose' },
        { hex: '#C0C0C0', name: 'Silver' },
        // Bold colors
        { hex: '#8B00FF', name: 'Violet' },
        { hex: '#9400D3', name: 'Purple' },
        { hex: '#4B0082', name: 'Indigo' },
        { hex: '#FFFF00', name: 'Yellow' },
        { hex: '#FF69B4', name: 'Pink' },
      ],
      presets: [
        {
          id: PRESETS.ELF_STRIPES,
          name: 'Elf Stripes',
          emoji: '🎄',
          color: 'green',
          dark: true,
        },
        {
          id: PRESETS.ELF_BOUNCE,
          name: 'Elf Bounce',
          emoji: '🎄',
          color: 'green',
          dark: true,
        },
        {
          id: PRESETS.PEPPERMINT_STRIPES,
          name: 'Peppermint Stripes',
          emoji: '🍬',
          color: 'red',
          dark: true,
        },
        {
          id: PRESETS.PEPPERMINT_BOUNCE,
          name: 'Peppermint Bounce',
          emoji: '🍬',
          color: 'red',
          dark: true,
        },
        {
          id: PRESETS.GLITTER,
          name: 'Rainbow Glitter',
          emoji: '🌈',
          color: 'purple',
          dark: true,
        },
        {
          id: PRESETS.GLITTER_TWINKLE,
          name: 'Rainbow Twinkle',
          emoji: '🌈',
          color: 'purple',
          dark: true,
        },
        {
          id: PRESETS.FIREWORKS,
          name: 'Fireworks',
          emoji: '🔥',
          color: 'blue',
          dark: true,
        },
        {
          id: PRESETS.TWINKLE_STARS,
          name: 'Twinkle Stars',
          emoji: '⭐',
          color: 'orange',
          dark: true,
        },
      ]
    };
  },
  methods: {
    setTreeColor(color) {
      this.selectedColor = color;
      console.log(`Setting tree to color: ${color}`);
      
      command('magic-tree', {
        action: 'color',
        color: color
      });
    },
    
    activatePreset(presetId) {
      // Clear selected color when activating a preset
      this.selectedColor = null;
      console.log(`Activating preset: ${presetId}`);
      
      command('magic-tree', {
        action: 'preset',
        presetId: presetId
      });
    }
  }
};
